import LinkIcon from '@mui/icons-material/Link'
import { Box, IconButton, List, ListItem, ListItemText, Popover, TextField, Tooltip } from '@mui/material'
import { FC, useState } from 'react'
import { HardwareTypes } from '../../classes/Hardware'
import { LinkType } from '../../classes/Item'
import useUnit from '../../hooks/useUnit'
import { InputWithoutSubmitWithUnitSupport, cmToIn, inToCm } from '../common/UnitComponents'

interface IProps {
    id: string
    name: string
    value: number
    extra: number
    parentItemProps: string[]
    links: LinkType[]
    type: HardwareTypes

    showExtra?: boolean

    handleChangeExtra(): void
    handlePerCmChange(perCM: number, name: string): void
    addLink(itemProp: string, hId: string): void
}

const ParamComponent: FC<IProps> = ({ showExtra = false, ...props }) => {

    const [linkOpen, setLinkOpen] = useState(false)
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)

    const { unit } = useUnit()

    return (
        <Box display='flex' alignItems='center'>
            {!(props.name === 'count' && props.type === 'parametric_hinge') && <Tooltip title={props.links.find(link => (link.hId === props.id && link.hProp.split('_')[0] === props.name))?.itemProp || ''} placement="top">
                <IconButton onClick={(e) => {
                    setLinkOpen(true)
                    setAnchorEl(e.currentTarget)
                }}>
                    <LinkIcon style={{
                        color: props.links.find(link => (link.hId === props.id && link.hProp.split('_')[0] === props.name)) ? '#00bd00' : ''
                    }} />
                </IconButton>
            </Tooltip>}

            {props.name === 'count' ? <TextField
                label={props.name}
                value={props.value}
                variant='outlined'
                size='small'
                style={{
                    width: 65,
                    marginRight: 10
                }}
            />
                : <InputWithoutSubmitWithUnitSupport
                    label={props.name}
                    valueInCm={props.value}
                    size='small'
                    width={110}
                    sx={{ mr: 1 }}
                />
            }

            {(props.name.split('_')[0] === 'count' && props.type === 'parametric_count') &&
                <TextField
                    label={'per' + (unit === 'cm' ? "CM" : "IN")}
                    value={(() => {
                        const valueInCm = props.links.find(link => (link.hId === props.id && link.hProp.split('_')[0] === props.name))?.hProp.split('_')[1]
                        return valueInCm ? (unit === 'cm' ? valueInCm : cmToIn(parseFloat(valueInCm))) : 1
                    })()
                    }
                    onChange={e => {
                        const newValue = parseInt(e.target.value)
                        const perCM = unit === 'cm' ? newValue : inToCm(newValue)
                        props.handlePerCmChange(perCM, props.name)
                    }}
                    variant='outlined'
                    size='small'
                    style={{
                        width: 65
                    }}
                />
            }
            {showExtra &&
                <TextField
                    label='extra'
                    value={props.extra}
                    onChange={props.handleChangeExtra}
                    variant='outlined'
                    size='small'
                    style={{
                        width: 65
                    }}
                />
            }
            <Popover
                open={linkOpen}
                anchorEl={anchorEl}
                onClose={() => { setLinkOpen(false) }}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                <List style={{ minWidth: 100 }}>
                    {props.parentItemProps.map(prop => prop !== 'thickness' && <ListItem
                        key={prop}
                        button
                        onClick={() => {
                            props.addLink(prop, props.id)
                            setLinkOpen(false)
                        }}>
                        <ListItemText primary={prop} />
                    </ListItem>
                    )}
                </List>
            </Popover>
        </Box>
    )
}

export default ParamComponent